<template>
  <v-col>
    <v-card v-if="this.reportData.length > 0">
      <!-- <v-row v-if="reportType === 'Admissions'" class="d-none d-md-flex pa-3">
        <v-col cols="12" md="6">
          <admissions-chart :chartInfo="chartInfo" :view="'report'" />
        </v-col>
        <v-col cols="12" md="6">
          <admissions-cost-chart :chartInfo="chartInfo" :view="'report'" />
        </v-col>
      </v-row>
      <v-row v-if="reportType === 'Brand Rx'" class="d-none d-md-flex pa-3">
        <v-col sm="12" lg="6">
          <brand-rx-count-chart :chartInfo="chartInfo" :view="'report'" />
        </v-col>
        <v-col sm="12" lg="6">
          <brand-rx-cost-chart :chartInfo="chartInfo" :view="'report'" />
        </v-col>
      </v-row>
      <v-row v-if="reportType === 'ER Visits'" class="d-none d-md-flex pa-3">
        <v-col sm="12" lg="6">
          <er-visits-chart :chartInfo="chartInfo" :view="'report'" />
        </v-col>
        <v-col sm="12" lg="6">
          <er-cost-chart :chartInfo="chartInfo" :view="'report'" />
        </v-col>
      </v-row>
      <v-row v-if="reportType === 'Outpatient'" class="d-none d-md-flex pa-3">
        <v-col sm="12" lg="6">
          <outpatient-chart :chartInfo="chartInfo" :view="'report'" />
        </v-col>
        <v-col sm="12" lg="6">
          <outpatient-cost-chart :chartInfo="chartInfo" :view="'report'" />
        </v-col>
      </v-row> -->
      <v-card-text>
        <v-row>
          <v-col cols="6" class="py-0 ma-3">
            <v-text-field
              class="py-0"
              v-model="search"
              label="Search"
              append-icon="mdi-search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col
            v-if="reportType === 'Chronic Conditions'"
            class="d-flex flex-row-reverse"
          >
            <v-chip>
              {{ conditionsCode }}
            </v-chip>
          </v-col>
          <v-col cols="4" md="6" lg="2" class="py-0" v-if="reportType === 'Readmissions'">
            <v-switch
              color="secondary"
              inset
              v-model="specialty"
              class="float-right my-0"
            >
              <template slot="prepend">
                <p class="pt-1 mr-2">{{ specialty ? "Specialty" : "Patients" }}</p>
              </template>
            </v-switch>
          </v-col>
          <v-col cols="12" class="py-0" v-if="tableIsGrouped">
            <div class="float-right">
              <v-btn color="secondary" text small @click="expandAll">Expand All</v-btn>
              <v-btn color="primary" text small @click="collapseAll">Collapse All</v-btn>
            </div>
          </v-col>
          <v-col
            v-if="reportType === 'Conditions Search'"
            class="d-flex flex-row-reverse"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip v-bind="attrs" v-on="on" class="subtitle-1">
                  {{ conditionsCode.CODE ? conditionsCode.CODE : "No Code" }}</v-chip
                >
              </template>
              <span class="subtitle-1">{{
                conditionsCode.DESCRIPTION
                  ? conditionsCode.DESCRIPTION
                  : "No Description Included"
              }}</span>
            </v-tooltip>
          </v-col>
          <v-col
            v-if="reportType == 'Diagnostic Conditions'"
            class="d-flex flex-row-reverse"
          >
            <v-chip class="subtitle-1">
              {{ conditionsCode.CODE ? conditionsCode.CODE : "No Code" }}</v-chip
            >
          </v-col>
          <v-col v-if="reportType === 'Frequent Flyer'">
            <v-select
              v-model="minimumVisits"
              :items="minVisitDropdownOptions"
              label="Minimum Visits"
              outlined
              dense
            >
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <div v-if="specialty === false">
        <v-data-table
          :headers="headers"
          :items="returnReportData"
          :search="search"
          :sort-by="sortColumn()"
          :sort-desc="true"
          :width="100"
          :footer-props="{
            'items-per-page-options': [25, 50, 75, 100, -1],
          }"
          :items-per-page="25"
          multi-sort
          :show-group-by="!tableIsGrouped"
          @update:group-by="tableIsGrouped = !tableIsGrouped"
          :group-desc="tableIsGrouped"
          return-object
          loading-text="Loading data..."
          class="elevation-0 col-md-12 m-auto"
        >
          <template
            v-slot:group.header="{ group, headers, isOpen, toggle, remove, groupBy }"
          >
            <td style="background: #fff" :colspan="headers.length">
              <v-btn @click="toggle" small icon :ref="group" :data-open="isOpen">
                <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                <v-icon v-else>mdi-chevron-down</v-icon>
              </v-btn>
              <span class="font-weight-bold">{{
                groupBy[0] === "AMOUNT"
                  ? "$" + group.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
                  : group
              }}</span>
              <v-icon small @click="remove">mdi-close</v-icon>
            </td>
          </template>

          <template v-slot:item.CLAIM_ID="{ item }">
            <v-chip small @click="openClaimDetails(item.CLAIM_ID)">{{
              item.CLAIM_ID
            }}</v-chip>
          </template>

          <template v-slot:item.PATIENT_ID="{ item }">
            <v-chip small @click="highCostPatientDetails(item.PATIENT_ID)">{{
              item.PATIENT_ID
            }}</v-chip>
          </template>

          <template v-slot:item.SPEC="{ item }">
            <v-chip small @click="openSpecDetails(item.SPEC.split('/').join(','))">{{
              item.SPEC
            }}</v-chip>
          </template>

          <template v-slot:item.AMOUNT="{ item }">
            <span>${{ formatCurrency(item.AMOUNT) }}</span>
          </template>

          <template v-slot:item.="{ item }">
            <v-chip
              small
              @click="openFrequentFlyerDetails(item._id, item.FREQ_FLYER_MEMBER_NAME)"
              >{{ item.FREQ_FLYER_MEMBER_NAME }}</v-chip
            >
          </template>

          <template v-slot:item.PMPM="{ item }">
            ${{ formatCurrency(item.PMPM) }}
          </template>

          <template v-slot:item.FREQ_FLYER_MEMBER_NAME="{ item }">
            <v-chip
              small
              @click="
                openFrequentFlyerDetails(item.FF_PATIENT_ID, item.FREQ_FLYER_MEMBER_NAME)
              "
              >{{ item.FREQ_FLYER_MEMBER_NAME }}</v-chip
            >
          </template>

          <template v-slot:item.NDC_NUMBER="{ item }">
            <v-chip small @click="openRxDetails(item.NDC_NUMBER, item.DRUG_NAME)">
              {{ item.NDC_NUMBER }}
            </v-chip>
          </template>

          <template v-slot:item.NAME_PRESCRIBER="{ item }">
            <v-chip small @click="openPrescriberDetails(item._id, item.NAME_PRESCRIBER)">
              {{
                item.NAME_PRESCRIBER === null ||
                item.NAME_PRESCRIBER === "," ||
                item.NAME_PRESCRIBER === " "
                  ? "NPI Not Found"
                  : item.NAME_PRESCRIBER
              }}
            </v-chip>
          </template>

          <template v-slot:item.DIAGNOSIS="{ item }">
            <v-chip small @click="openConditionsModal(item.ITEMS, item.DIAGNOSIS)">
              {{ item.DIAGNOSIS }}
            </v-chip>
          </template>

          <template v-slot:item.LAST_SERVICE="{ item }">
            {{ item.LAST_SERVICE ? item.LAST_SERVICE : "-" }}
          </template>

          <template v-slot:item.DETAILS="{ item }">
            <patient-modal :patient="item" :insurance="insurance" />
          </template>

          <template v-slot:item.NAME="{ item }">
            <v-chip
              small
              @click="openReadmissionsModal(item.readmissionsArray, item.NAME)"
            >
              {{ item.NAME ? item.NAME : "Other" }}
            </v-chip>
          </template>

          <template v-slot:item.MLR="{ item }">
            {{
              item.MLR
                ? item.MLR.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") + "%"
                : "-"
            }}
          </template>

          <template v-slot:item.MRA="{ item }">
            {{ item.MRA ? item.MRA.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") : "-" }}
          </template>

          <template v-slot:item.TOTAL_EXPENSES="{ item }">
            {{
              item.TOTAL_EXPENSES
                ? "$" + item.TOTAL_EXPENSES.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
                : "-"
            }}
          </template>

          <template v-slot:item.TOTAL_REVENUE="{ item }">
            {{
              item.TOTAL_REVENUE
                ? "$" + item.TOTAL_REVENUE.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
                : "-"
            }}
          </template>

          <template slot="group.summary" slot-scope="props" style="background: #f00">
            <td style="background: #fff" :colspan="props.headers.length">
              Total Amount: ${{
                formatCurrency(props.items.reduce((a, rec) => a + rec.AMOUNT, 0))
              }}
            </td>
          </template>

          <template slot="body.append" slot-scope="props">
            <tr v-if="!(reportType === 'Patient MLR' || reportType === 'Frequent Flyer')">
              <td
                :colspan="props.headers.length"
                class="primary--text text--lighten-3 font-weight-medium px-0"
              >
                <v-expansion-panels v-model="panel">
                  <v-expansion-panel class="rounded-0">
                    <v-expansion-panel-header
                      ><span>{{
                        panel === undefined ? "More Info" : "Less Info"
                      }}</span></v-expansion-panel-header
                    >
                    <v-card width="props.headers.length">
                      <v-expansion-panel-content>
                        <v-row>
                          <!-- Displayed Records -->
                          <v-col cols="12" lg="6">
                            <v-card outlined height="100%" class="pa-3">
                              <v-card-title>
                                Displayed Records
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon small class="mx-2" v-on="on"
                                      >mdi-information-outline</v-icon
                                    >
                                  </template>
                                  <span>Records displayed after applying filters.</span>
                                </v-tooltip>
                              </v-card-title>
                              <v-card-text class="text-subtitle-1">
                                <div>
                                  Number of Displayed {{ reportValueType }}:
                                  <span class="text--primary">{{
                                    props.items.length
                                  }}</span>
                                </div>
                                <div>
                                  Total:
                                  <span class="text--primary"
                                    >${{
                                      formatCurrency(
                                        props.items.reduce((a, rec) => a + rec.AMOUNT, 0)
                                      )
                                    }}</span
                                  >
                                </div>
                                <div>
                                  Average:
                                  <span class="text--primary"
                                    >${{
                                      formatCurrency(
                                        props.items.reduce(
                                          (a, rec) => a + rec.AMOUNT,
                                          0
                                        ) /
                                          (props.items.length > 0
                                            ? props.items.length
                                            : 1)
                                      )
                                    }}</span
                                  >
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>

                          <!-- Total Records -->
                          <v-col cols="12" lg="6">
                            <v-card outlined height="100%" class="pa-3">
                              <v-card-title>
                                Total Records
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon small class="mx-2" v-on="on"
                                      >mdi-information-outline</v-icon
                                    >
                                  </template>
                                  <span
                                    >Total records in the database, without any
                                    filters.</span
                                  >
                                </v-tooltip>
                              </v-card-title>
                              <v-card-text class="text-subtitle-1">
                                <div>
                                  Total Number of {{ reportValueType }}:
                                  <span class="text--primary">{{ numOfClaims }}</span>
                                </div>
                                <div>
                                  Total:
                                  <span class="text--primary"
                                    >${{ formatCurrency(totalClaimCost) }}</span
                                  >
                                </div>
                                <div>
                                  Average:
                                  <span class="text--primary"
                                    >${{ formatCurrency(avgClaimCost) }}</span
                                  >
                                </div>
                                <div v-if="!specialty">
                                  Median:
                                  <span class="text--primary">{{
                                    medianClaimValue
                                  }}</span>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-card>
                  </v-expansion-panel>
                </v-expansion-panels>
              </td>
            </tr>
          </template>

          <template slot="footer">
            <ExportCSV
              :data="this.csvData"
              :name="
                'Top ' +
                this.reportLimit * 100 +
                '% ' +
                this.reportType +
                ' ' +
                this.startDate +
                '.csv'
              "
            >
              <v-btn
                color="secondary"
                @click="exportData()"
                text
                small
                class="export-button"
                >Export to CSV</v-btn
              >
            </ExportCSV>
          </template>
        </v-data-table>
      </div>

      <div v-if="specialty">
        <v-data-table
          :headers="headers"
          :items="specialtyData"
          :search="search"
          :sort-by="sortColumn()"
          :sort-desc="descOrder()"
          :footer-props="{
            'items-per-page-options': [25, 50, 75, 100, -1],
          }"
          :items-per-page="25"
          multi-sort
          :show-group-by="!tableIsGrouped"
          @update:group-by="tableIsGrouped = !tableIsGrouped"
          loading-text="Loading data..."
          class="elevation-0 col-md-12 m-auto"
        >
          <template v-slot:group.header="{ group, headers, isOpen, toggle, remove }">
            <td style="background: #fff" :colspan="headers.length">
              <v-btn @click="toggle" small icon :ref="group" :data-open="isOpen">
                <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                <v-icon v-else>mdi-chevron-down</v-icon>
              </v-btn>
              <span class="font-weight-bold">{{ group }}</span>
              <v-icon small @click="remove">mdi-close</v-icon>
            </td>
          </template>

          <template v-slot:item.SPEC="{ item }">
            <v-chip small @click="openSpecDetails(item.SPEC.split('/').join(','))">{{
              item.SPEC
            }}</v-chip>
          </template>

          <template v-slot:item.DETAILS="{ item }">
            <patient-modal :patient="item" :insurance="insurance" />
          </template>

          <template v-slot:item.PMPM="{ item }">
            ${{ formatCurrency(item.PMPM) }}
          </template>

          <template v-slot:item.AMOUNT="{ item }">
            <span>${{ formatCurrency(item.AMOUNT) }}</span>
          </template>

          <template v-slot:item.NAME="{ item }">
            <v-chip
              small
              @click="openReadmissionsModal(item.readmissionsArray, item.NAME)"
            >
              {{ item.NAME ? item.NAME : "Other" }}
            </v-chip>
          </template>

          <template slot="body.append" slot-scope="props">
            <!-- renders with claims for reports by claim -->
            <tr v-if="reportType !== 'Patient MLR'">
              <td
                :colspan="props.headers.length"
                class="primary--text text--lighten-3 font-weight-medium px-0"
              >
                <v-expansion-panels v-model="panel">
                  <v-expansion-panel class="rounded-0">
                    <v-expansion-panel-header
                      ><span>{{
                        panel === undefined ? "More Info" : "Less Info"
                      }}</span></v-expansion-panel-header
                    >
                    <v-card width="props.headers.length">
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12" lg="6">
                            <v-card outlined height="100%" class="pa-3">
                              <v-card-title>Total {{ reportValueType }}</v-card-title>
                              <v-card-text class="text-subtitle-1">
                                <div>
                                  Number of {{ reportValueType }}:
                                  <span class="text--primary">{{ numOfClaims }}</span>
                                </div>
                                <div>
                                  Total:
                                  <span class="text--primary"
                                    >${{ formatCurrency(totalClaimCost) }}</span
                                  >
                                </div>
                                <div>
                                  Average:
                                  <span class="text--primary"
                                    >${{ formatCurrency(avgClaimCost) }}</span
                                  >
                                </div>
                                <div v-if="!specialty">
                                  Median:
                                  <span class="text--primary">{{
                                    medianClaimValue
                                  }}</span>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col cols="12" lg="6">
                            <v-card
                              outlined
                              height="100%"
                              class="pa-3"
                              v-if="
                                reportType !== 'Diagnostic Conditions' &&
                                reportType !== 'Chronic Conditions' &&
                                reportType !== 'Specialists' &&
                                specialty !== true
                              "
                            >
                              <v-card-title>
                                Displayed {{ reportValueType }}
                              </v-card-title>
                              <v-card-text class="text-subtitle-1">
                                <div>
                                  Number of {{ reportValueType }}:
                                  <span class="text--primary">{{
                                    props.items.length
                                  }}</span>
                                </div>
                                <div>
                                  Total:
                                  <span class="text--primary"
                                    >${{
                                      formatCurrency(
                                        props.items.reduce((a, rec) => a + rec.AMOUNT, 0)
                                      )
                                    }}</span
                                  >
                                </div>
                                <div>
                                  Average:
                                  <span class="text--primary"
                                    >${{
                                      formatCurrency(
                                        props.items.reduce(
                                          (a, rec) => a + rec.AMOUNT,
                                          0
                                        ) /
                                          (props.items.length > 0
                                            ? props.items.length
                                            : 1)
                                      )
                                    }}</span
                                  >
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-card>
                  </v-expansion-panel>
                </v-expansion-panels>
              </td>
            </tr>
          </template>

          <template slot="footer">
            <ExportCSV
              :data="this.csvData"
              :name="
                'Top ' +
                this.reportLimit * 100 +
                '% ' +
                this.reportType +
                ' ' +
                this.startDate +
                '.csv'
              "
            >
              <v-btn color="secondary" text small class="export-button"
                >Export to CSV</v-btn
              >
            </ExportCSV>
          </template>
        </v-data-table>
      </div>

      <ClaimDetails
        :insurance="insurance"
        :claimID="claimDetailsID"
        v-model="claimDetailsDialog"
      />
      <ClaimFundTypes
        :insurance="insurance"
        :claimID="fundTypesClaimID"
        :patientID="fundTypesPatientID"
        :startDate="startDate"
        :endDate="endDate"
        v-model="claimFundTypesDialog"
      />
      <highCostPatientDetails
        :insurance="insurance"
        :startDate="startDate"
        :endDate="endDate"
        :patientID="highCostPatientID"
        :reportType="reportType"
        v-model="highCostPatientDialog"
      />
      <RxDetails
        :insurance="insurance"
        :rxID="rxDetailsID"
        :rxName="rxDetailsName"
        :groups="groups"
        :providers="providers"
        :locations="locations"
        :start="startDate"
        :end="endDate"
        v-model="rxDetailsDialog"
      />
      <SpecDetails
        v-model="specDetailsDialog"
        :insurance="insurance"
        :spec="specDetailsID"
        :start="startDate"
        :end="endDate"
        :groups="groups"
        :providers="providers"
        :locations="locations"
      />
      <frequentFlyerDetails
        v-model="frequentFlyerDialog"
        :insurance="insurance"
        :frequentflyerName="frequentflyerName"
        :frequentFlyerID="frequentFlyerID"
        :startDate="startDate"
        :endDate="endDate"
        :groups="groups"
        :providers="providers"
        :locations="locations"
      />
      <prescriberDetails
        :insurance="insurance"
        :prescriber="prescriberName"
        :prescriberID="prescriberID"
        :groups="groups"
        :providers="providers"
        :locations="locations"
        :start="startDate"
        :end="endDate"
        v-model="prescriberDialog"
      />
      <ConditionsModal
        :items="conditionsItems"
        :patientID="conditionsPatientID"
        :insurance="insurance"
        :conditionsCode="conditionsCode.CODE"
        :conditionsType="conditionsType"
        :startDate="startDate"
        :endDate="endDate"
        :reportType="reportType"
        v-model="conditionsDialog"
      />
      <PatientMlrDetails
        :insurance="insurance"
        :patID="detailsId"
        :patName="detailsName"
        :startDate="startDate"
        :endDate="endDate"
        :groups="groups"
        :providers="providers"
        :locations="locations"
        v-model="detailsDialog"
      />
      <ReadmissionsModal
        :insurance="insurance"
        :patient_name="readmitName"
        :specialty="specialty"
        :startDate="startDate"
        :endDate="endDate"
        :groups="groups"
        :providers="providers"
        :locations="locations"
        :readmissionsArray="readmissionsArray"
        v-model="readmitDialog"
      />
    </v-card>
  </v-col>
</template>

<script>
import axios from 'axios';
import ExportCSV from 'vue-json-csv';
import PatientModal from '../PatientModal.vue';
import ClaimDetails from '../claimDetails.vue';
import ClaimFundTypes from '../claimFundTypes.vue';
import highCostPatientDetails from './highCostPatientDetails.vue';
import frequentFlyerDetails from './frequentFlyerDetails.vue';
import RxDetails from './rxDetails.vue';
import SpecDetails from './SpecDetails.vue';
import prescriberDetails from './prescribersDetails.vue';
import ConditionsModal from './conditionsModal.vue';
import PatientMlrDetails from './PatientMlrDetails.vue';
import ReadmissionsModal from './readmissionsModal.vue';
// import admissionsChart from '../dashboardCharts/admissions.vue';
// import admissionsCostChart from '../dashboardCharts/admissionsCost.vue';
// import brandRxCostChart from '../dashboardCharts/brandRxCost.vue';
// import brandRxCountChart from '../dashboardCharts/brandRxCount.vue';
// import erVisitsChart from '../dashboardCharts/erVisits.vue';
// import erCostChart from '../dashboardCharts/erCost.vue';
// import outpatientChart from '../dashboardCharts/outpatientVisits.vue';
// import outpatientCostChart from '../dashboardCharts/outpatientCost.vue';

export default {
  name: 'UtilizationReports',
  props: [
    'organizations',
    'groups',
    'providers',
    'locations',
    'insurance',
    'startDate',
    'endDate',
    'reportType',
    'reportData',
    'chartInfo',
    'calculatedClaimValues',
    'numOfClaims',
    'totalClaimCost',
    'avgClaimCost',
    'medianClaimValue',
    'reportLimit',
    'conditionsCode',
    'conditionsType',
    'specialtyData',
    'minVisits',
  ],
  components: {
    PatientModal,
    ClaimDetails,
    ClaimFundTypes,
    highCostPatientDetails,
    frequentFlyerDetails,
    RxDetails,
    SpecDetails,
    prescriberDetails,
    ConditionsModal,
    PatientMlrDetails,
    ReadmissionsModal,
    // admissionsChart,
    // admissionsCostChart,
    // brandRxCostChart,
    // brandRxCountChart,
    // erVisitsChart,
    // erCostChart,
    // outpatientChart,
    // outpatientCostChart,
    ExportCSV,
  },
  data() {
    return {
      search: '',
      pagination: '',
      tableIsGrouped: false,
      panel: 0,
      claimFundTypesDialog: false,
      fundTypesClaimID: '',
      fundTypesPatientID: '',
      claimDetailsDialog: false,
      claimDetailsID: '',
      highCostPatientDialog: false,
      highCostPatientID: '',
      rxDetailsDialog: false,
      rxDetailsID: '',
      rxDetailsName: '',
      specDetailsDialog: false,
      specDetailsID: '',
      frequentFlyerDialog: '',
      frequentFlyerID: '',
      frequentflyerName: '',
      prescriberDialog: false,
      prescriberID: '',
      prescriberName: '',
      conditionsDialog: false,
      conditionsItems: [],
      detailsDialog: false,
      detailsId: '',
      detailsName: '',
      readmissions: [],
      readmitName: '',
      readmitDialog: false,
      specialty: false,
      headers: [],
      readmissionsArray: [],
      conditionsPatientID: '',
      csvData: [],
      mappedExportData: [],
      filteredData: [],
      minimumVisits: 0,
      minVisitDropdownOptions: [],
    };
  },
  methods: {
    getHeaders() {
      const reportType = this.reportType.toLowerCase();
      if (
        reportType === 'admissions'
        || reportType === 'claims expense'
        || reportType === 'er visits'
        || reportType === 'observations'
        || reportType === 'outpatient'
        || reportType === 'home health'
      ) {
        this.headers = [
          { text: 'Claim Number', value: 'CLAIM_ID' },
          { text: 'PCP', value: 'PCP_NAME' },
          { text: 'Servicer Name', value: 'SERVICER_NAME' },
          { text: 'Patient Name', value: 'MEMBER_NAME' },
          // { text: 'DOB', value: 'BIRTH_DATE' },
          { text: 'Start Date', value: 'START_DATE' },
          { text: 'End Date', value: 'END_DATE' },
          { text: 'Amount', value: 'AMOUNT' },
          { text: 'Status', value: 'STATUS' },
          { text: 'Details', value: 'DETAILS' },
          { text: 'Line EOP Description', value: 'LINE_EOP_DESC' },
          { text: 'EOP Description', value: 'EOP_DESC' },
        ];
      } else if (reportType === 'diagnostic conditions') {
        this.headers = [
          { text: 'Patient ID', value: 'ID' },
          { text: 'Patient Name', value: 'PATIENT_NAME' },
          { text: 'Provider Name', value: 'PCP_NAME' },
          // { text: 'DOB', value: 'DOB' },
          { text: 'Amount', value: 'AMOUNT' },
          { text: 'Status', value: 'STATUS' },
          { text: 'Details', value: 'DETAILS' },
          { text: 'Line EOP Description', value: 'LINE_EOP_DESC' },
          { text: 'EOP Description', value: 'EOP_DESC' },
          // { text: 'Diagnostic Condition', value: 'DIAGNOSIS' },
          // { text: '# of Claims', value: 'COUNT' },
        ];
      } else if (reportType === 'chronic conditions') {
        this.headers = [
          { text: 'Patient ID', value: 'ID' },
          { text: 'Patient Name', value: 'PATIENT_NAME' },
          { text: 'Provider Name', value: 'PCP_NAME' },
          // { text: 'DOB', value: 'BIRTH_DATE' },
          { text: 'Amount', value: 'AMOUNT' },
          { text: 'Status', value: 'STATUS' },
          { text: 'Details', value: 'DETAILS' },
          { text: 'Line EOP Description', value: 'LINE_EOP_DESC' },
          { text: 'EOP Description', value: 'EOP_DESC' },
        ];
      } else if (reportType === 'specialists') {
        this.headers = [
          { text: 'Specialist', value: 'SPEC' },
          { text: '# of Claims', value: 'NUMCLAIMS' },
          { text: 'Amount', value: 'AMOUNT' },
        ];
      } else if (reportType === 'brand rx') {
        this.headers = [
          { text: 'Claim ID', value: 'RX_CLAIM_ID' },
          { text: 'Member ID', value: 'ID' },
          // { text: 'Provider Name', value: 'PCP_NAME' },
          { text: 'Patient Name', value: 'MEMBER_NAME' },
          // { text: 'DOB', value: 'BIRTH_DATE' },
          { text: 'Service Date', value: 'SERVICE_DATE' },
          { text: 'Prescriber Name', value: 'PRESCRIBER_NAME' },
          { text: 'Pharmacy', value: 'PHARMACY_NAME' },
          { text: 'Drug Name', value: 'DRUG_NAME' },
          { text: 'Interchange Drug', value: 'INTERCHANGE_DRUG' },
          { text: 'Qty', value: 'QTY' },
          { text: 'Amount', value: 'AMOUNT' },
          { text: 'Details', value: 'DETAILS' },
        ];
      } else if (reportType === 'high cost patients') {
        this.headers = [
          { text: 'Patient ID', value: 'PATIENT_ID' },
          { text: 'Patient Name', value: 'HIGH_COST_MEMBER_NAME' },
          { text: 'Provider Name', value: 'PCP_NAME' },
          // { text: 'DOB', value: 'BIRTH_DATE' },
          { text: 'Claim Count', value: 'CLAIM_COUNT' },
          { text: 'Amount', value: 'AMOUNT' },
          { text: 'Status', value: 'STATUS' },
          { text: 'Details', value: 'DETAILS' },
          { text: 'Line EOP Description', value: 'LINE_EOP_DESC' },
          { text: 'EOP Description', value: 'EOP_DESC' },
        ];
      } else if (reportType === 'high cost rx') {
        this.headers = [
          { text: 'NDC Code', value: 'NDC_NUMBER' },
          { text: 'Drug Name', value: 'DRUG_NAME' },
          { text: 'Interchange Drug', value: 'INTERCHANGE_DRUG' },
          { text: 'Total Cost', value: 'AMOUNT' },
        ];
      } else if (reportType === 'frequent flyer') {
        this.headers = [
          { text: 'Patient ID', value: 'ID' },
          { text: 'Patient Name', value: 'FREQ_FLYER_MEMBER_NAME' },
          { text: 'Provider Name', value: 'PCP_NAME' },
          // { text: 'DOB', value: 'BIRTH_DATE' },
          { text: 'Admission Count', value: 'ADMISSION_COUNT' },
          { text: 'ER Claim  Count', value: 'ER_VISIT_COUNT' },
          { text: 'Amount', value: 'AMOUNT' },
          { text: 'Status', value: 'STATUS' },
          { text: 'Details', value: 'DETAILS' },
        ];
      } else if (reportType === 'high cost prescribers') {
        this.headers = [
          { text: 'Prescriber Name', value: 'NAME_PRESCRIBER' },
          { text: '# of Claims', value: 'NUM_CLAIMS' },
          { text: 'Amount', value: 'AMOUNT' },
        ];
      } else if (reportType === 'patient mlr') {
        this.headers = [
          { text: 'Provider Name', value: 'PCP_NAME' },
          { text: 'Patient Name', value: 'MEMBER_NAME' },
          { text: 'DOB', value: 'BIRTH_DATE' },
          { text: 'Revenue', value: 'TOTAL_REVENUE' },
          { text: 'Expenses', value: 'TOTAL_EXPENSES' },
          { text: 'MRA', value: 'MRA' },
          { text: 'MLR', value: 'MLR' },
          { text: 'Details', value: 'DETAILS' },
        ];
      } else if (reportType === 'readmissions') {
        if (this.specialty) {
          this.headers = [
            { text: 'Specialty', value: 'NAME' },
            { text: '30 Day Readmissions', value: 'COUNT' },
            { text: 'Unique Member Count', value: 'PAT_UNIQUE_COUNT' },
            { text: 'Amount', value: 'AMOUNT' },
            { text: 'Status', value: 'STATUS' },
            { text: 'PMPM', value: 'PMPM' },
          ];
        } else {
          this.headers = [
            { text: 'Patient ID', value: 'SUBSCRIBER_ID' },
            { text: 'Patient Name', value: 'MEMBER_NAME' },
            { text: 'Provider Name', value: 'PCP_NAME' },
            { text: 'DOB', value: 'BIRTH_DATE' },
            { text: '30 Day Readmissions', value: 'COUNT' },
            { text: 'Amount', value: 'AMOUNT' },
            // { text: 'Status', value: 'STATUS' },
            { text: 'Details', value: 'DETAILS' },
          ];
        }
      } else if (reportType === 'conditions search') {
        this.headers = [
          { text: 'Patient ID', value: 'ID' },
          { text: 'Patient Name', value: 'PATIENT_NAME' },
          { text: 'Provider Name', value: 'PCP_NAME' },
          // { text: 'DOB', value: 'DOB' },
          { text: 'Amount', value: 'AMOUNT' },
          { text: 'Status', value: 'STATUS' },
          { text: 'Details', value: 'DETAILS' },
        ];
      }
    },
    openClaimDetails(id) {
      this.claimDetailsDialog = true;
      this.claimDetailsID = id;
    },
    openClaimFundTypes(id, isPatient = false) {
      this.claimFundTypesDialog = true;

      if (isPatient) {
        this.fundTypesPatientID = id;
        this.fundTypesClaimID = '';
      } else {
        this.fundTypesClaimID = id;
        this.fundTypesPatientID = '';
      }
    },
    openSpecDetails(id) {
      this.specDetailsDialog = true;
      this.specDetailsID = id;
    },
    highCostPatientDetails(id) {
      this.highCostPatientDialog = true;
      this.highCostPatientID = id;
    },
    openRxDetails(id, name) {
      this.rxDetailsDialog = true;
      this.rxDetailsID = id;
      this.rxDetailsName = name;
    },
    openFrequentFlyerDetails(id, name) {
      this.frequentFlyerDialog = true;
      this.frequentFlyerID = id;
      this.frequentflyerName = name;
    },
    openPrescriberDetails(id, name) {
      this.prescriberDialog = true;
      if (id === null && name === null) {
        this.prescriberID = 'null';
        this.prescriberName = 'NPI not found';
      } else {
        this.prescriberID = id;
        this.prescriberName = name;
      }
    },
    openConditionsModal(id) {
      this.conditionsPatientID = id;
      this.conditionsDialog = true;
    },
    openPatientMlrDetails(id, name) {
      this.detailsDialog = true;
      this.detailsId = id;
      this.detailsName = name;
    },
    openReadmissionsModal(readmits, name) {
      this.readmitDialog = true;
      this.readmitName = name;
      this.readmissionsArray = readmits;
    },
    collapseAll() {
      Object.keys(this.$refs).forEach((k) => {
        if (this.$refs[k] && this.$refs[k].$attrs['data-open']) {
          this.$refs[k].$el.click();
        }
      });
    },
    expandAll() {
      Object.keys(this.$refs).forEach((k) => {
        if (this.$refs[k] && !this.$refs[k].$attrs['data-open']) {
          this.$refs[k].$el.click();
        }
      });
    },
    formatCurrency(c) {
      return c === (undefined || null)
        ? 'Undefined'
        : c.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    sortColumn() {
      const reportType = this.reportType.toLowerCase();
      let sort = '';
      switch(reportType){
        case 'patient mlr':
          sort = 'MLR';
        break;
        case 'brand rx':
          sort = 'SERVICE_DATE';
        break;
        default:
          sort = 'AMOUNT';
      }
      return sort;
    },
    descOrder(){
      const reportType = this.reportType.toLowerCase();
      let sort = '';
      switch(reportType){
        case 'brand rx':
          sort = false;
          break;
        default:
          sort = true;
      }
      return sort;
    },
    exportData() {
      if (this.reportType === 'Claims Expense') {
        this.mappedExportData.forEach((obj) => {
          delete obj._id;
          this.csvData.push(obj);
        });
      } else {
        this.csvData = [];
        this.reportData.forEach((obj) => {
          delete obj._id;
          this.csvData.push(obj);
        });
      }
    },
    filterFreqFlyerData() {
      this.filteredData = [];
      // Loop through reportData and return the objects that meet the minimumVisits
      this.filteredData = this.reportData.map((obj) => {
        if (obj.ADMISSION_COUNT >= parseInt(this.minimumVisits)) {
          return obj;
        }
      });
      // Remove undefined from the filteredData array
      this.filteredData = this.filteredData.filter(elem => elem !== undefined);
    },
    calcMinVisitDropdownOptions() {
      if (parseInt(this.minVisits) === 0) {
        this.minVisitDropdownOptions = [0, 5, 10, 15, 20];
      } else {
        this.minVisitDropdownOptions = [
          0,
          parseInt(this.minVisits),
          parseInt(this.minVisits) * 2,
          parseInt(this.minVisits) * 3,
          parseInt(this.minVisits) * 4,
        ];
      }
    },
  },
  computed: {
    returnReportData() {
      if (this.reportType === 'Frequent Flyer') {
        return this.filteredData;
      }
      return this.reportData;
    },
    reportValueType() {
      if (
        this.reportType === 'Diagnostic Conditions'
        || this.reportType === 'Chronic Conditions'
        || this.reportType === 'Specialists'
        || this.specialty === true
      ) {
        return 'Categories';
      }
      if (
        this.reportType === 'Frequent Flyer'
        || this.reportType === 'High Cost Patients'
      ) {
        return 'Patients';
      }
      if (this.reportType === 'High Cost Prescribers') {
        return 'Prescribers';
      }
      if (this.reportType === 'High Cost Rx') {
        return 'Prescriptions';
      }
      return 'Claims';
    },
  },
  watch: {
    minimumVisits() {
      this.filterFreqFlyerData();
    },
    // Watch every dropdown and run report again on change
    reportData() {
      this.search = '';
      this.tableIsGrouped = false;
      this.getHeaders();
      // if (this.reportType === 'Claims Expense') {
      //   axios
      //     .get(
      //       `api/claims/export/${this.insurance}/${this.startDate}/${
      //         this.endDate
      //       }/groups=${this.groups}/providers=${this.providers}/locs=${
      //         this.locations
      //       }/${0.05}`,
      //     )
      //     .then((response) => {
      //       this.mappedExportData = response.data.data;
      //     });
      // }
      if (this.reportType === 'Frequent Flyer') {
        // Assign minimumVisits for the dropdown in the report
        this.minimumVisits = parseInt(this.minVisits);
        this.calcMinVisitDropdownOptions();
        this.filterFreqFlyerData();
      }
    },
    specialty() {
      this.getHeaders();
    },
    prescriberDialog() {
      if (this.prescriberDialog === false) {
        this.prescriberID = '';
      }
    },
    rxDetailsDialog() {
      if (this.rxDetailsDialog === false) {
        this.rxDetailsID = '';
      }
    },
    readmitDialog() {
      if (this.readmitDialog === false) {
        this.readmits = [];
      }
    },
    detailsDialog() {
      if (this.detailsDialog === false) {
        this.detailsId = '';
      }
    },
    frequentFlyerDialog() {
      if (this.frequentFlyerDialog === false) {
        this.frequentFlyerID = '';
      }
    },
    highCostPatientDialog() {
      if (this.highCostPatientDialog === false) {
        this.highCostPatientID = '';
      }
    },
    specDetailsDialog() {
      if (this.specDetailsDialog === false) {
        this.specDetailsID = '';
      }
    },
    claimDetailsDialog() {
      if (this.claimDetailsDialog === false) {
        this.claimDetailsID = '';
      }
    },
  },
};
</script>

<style scoped>
.export-button {
  position: absolute;
  left: 10px;
  bottom: 20px;
}
</style>
